export default class ApeHostNotifications {
  private static notifiers: Function[];
  static notify(event: Object) {
    this.notifiers = this.notifiers || [];
    this.notifiers.forEach(notifier => notifier(event));
  }

  static pushNotifier(notifier: Function) {
    this.notifiers = this.notifiers || [];
    this.notifiers.push(notifier);
  }

  static removeNotifier(notifier: Function) {
    this.notifiers = this.notifiers || [];
    this.notifiers = this.notifiers.filter(item => item !== notifier);
  }
}
